module.exports = __webpack_public_path__ + "img/shengTing.bb2f3ac2.jpg";